import { render } from "./Navbar.component.vue?vue&type=template&id=e850094a&ts=true"
import script from "./Navbar.component.vue?vue&type=script&lang=ts"
export * from "./Navbar.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__